import {
  FormHelperText,
  Stack,
  TextField,
  type TextFieldProps,
  Typography
} from '@mui/material'
import React from 'react'
import {
  type ControllerFieldState,
  type ControllerRenderProps
} from 'react-hook-form'
import { Link as RouterLink, type To } from 'react-router-dom'

import { URLHelperText } from 'components/services/create/URLHelperText'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { type TeamExternalIntegration } from 'types/api/status-checks/status-check'

export const MonitorUrlFieldInput: React.FC<
  TextFieldProps & {
    externalIntegration: TeamExternalIntegration | undefined
    field: ControllerRenderProps<StatusCheckFormValues, 'monitorUrl'>
    fieldState: ControllerFieldState
    label?: string
    to?: To
  }
> = ({ externalIntegration, field, fieldState, label, to, ...props }) => {
  const { error } = fieldState

  return (
    <Stack spacing={0}>
      <TextField
        {...field}
        {...props}
        aria-describedby="monitor-url-helper-text"
        data-testid="status-check-monitor-url-input"
        error={Boolean(error)}
        helperText={error?.message}
        label={label ?? 'Monitor URL'}
        value={field.value ?? ''}
      />
      {error?.type === 'is-monitor-url-already-in-use' && to && (
        <FormHelperText id="link-to-existing-health-check">
          <Typography variant="caption">
            <RouterLink to={to}>Go to existing Health Check</RouterLink>
          </Typography>
        </FormHelperText>
      )}
      <FormHelperText id="monitor-url-helper-text">
        <URLHelperText integration={externalIntegration} />
      </FormHelperText>
    </Stack>
  )
}
